import { isEmpty } from "lodash";
import * as React from "react";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { NoSpecial, phoneWithSpaceAndPlusSign } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { errorMsg } from "../../../../../../Admin/Network/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../../Resource/Contents";
import { CedingSchemeSearchInputEditor } from "./CedingSchemeSearchInput";

interface ICedingSchemeProps extends IProcessComponentProps {
    type: SubAccountType;
    index: number;
    showElectronicRerRegistrationSupported?: boolean;
    isStockIsa?: boolean;
    hasCertificatedSharesAndEquities?: boolean;
    onProviderSelected?: (v) => void;
    onAccountNumberChange?: (v) => void;
    externalOwnerShip?: any;
    jouneryType?: processTypeEnum;
}

interface ICedingSchemeState {
    isAddManual?: boolean;
    isRegistrationSupported?: boolean;
    isFromQuote?: boolean;
    isManualCedingSchemeExpanded?: boolean;
    mannuallyName?: string;
}

export class CedingScheme extends ProcessComponent<ICedingSchemeProps, ICedingSchemeState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isAddManual: props.data?.Reference ? true : false,
            isRegistrationSupported: false,
            isFromQuote: !isEmpty(getQueryParameters()["quoteid"]),
            isManualCedingSchemeExpanded: false,
            mannuallyName: props.data?.Reference ? props.data?.Name : null,
        };
        this.getSpecifyCedingSchemaInfo();
    }

    private hideAddManual() {
        this.props.onChange({ Address: null, ContactName: null, PhoneNumber: null, Reference: null });
        this.setState({ isAddManual: false, isManualCedingSchemeExpanded: false, mannuallyName: null });
    }

    componentWillUpdate(nextProps: ICedingSchemeProps, nextStat: any): void {
        super.componentWillUpdate(nextProps, nextStat);
        if (nextProps.hasCertificatedSharesAndEquities == true && this.props.data?.ProviderId != null) {
            this.hideAddManual();
        }
    }

    isValid() {
        const flag = super.isValid();
        console.log(this.props.externalOwnerShip?.Certificated);
        const ownerShipFlag =
            this.props.externalOwnerShip == undefined || this.props.externalOwnerShip?.Certificated === false;
        if (ownerShipFlag && ((!this.state.isAddManual && this.props.data?.Name == null) || (this.state.isAddManual && !this.isAddManualFilled()))) {
            this.props.showErrorMsgPopUp(
                [`Please choose a ceding scheme or add one manually for transfer in ${this.props.index}`],
                true
            );
            return false;
        } else {
            return flag;
        }
    }

    private getSpecifyCedingSchemaInfo() {
        const { data, type } = this.props;
        const { isFromQuote } = this.state;
        if (isFromQuote && data?.Name) {
            NewBusinessAction.getSpecifyCedingSchema(type, data?.Name, (callback) => {
                if (callback) {
                    const cedingInfo = callback.filter((v) => v.Id == data?.ProviderId)[0];
                    if (cedingInfo) {
                        this.setState({ isRegistrationSupported: cedingInfo.IsSupportElectronicReRegistration });
                    }
                }
            });
        }
    }

    private getElectronicRgistrationValue() {
        const { isFromQuote, isRegistrationSupported } = this.state;
        const { data } = this.props;
        if (isFromQuote) {
            return isRegistrationSupported ? "Yes" : "No";
        } else {
            return data?.IsSupportElectronicReRegistration ? "Yes" : "No";
        }
    }

    private isAddManualFilled() {
        const { data } = this.props;
        return data?.Reference && data?.ContactName && data?.PhoneNumber && data?.Name && data?.Address.Line1;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <CedingSchemeSearchInputEditor
                    // label="Ceding scheme"
                    value={null}
                    onSelected={(val) => {
                        this.hideAddManual();
                        onChange({
                            ProviderId: val.Id,
                            Name: val.Name,
                            IsSupportElectronicReRegistration: val.IsSupportElectronicReRegistration,
                            Address: {
                                Line1: val.Line1,
                                Line2: val.Line2,
                                Line3: val.Line3,
                                Postcode: val.PostCode
                            },
                            PhoneNumber: val.PhoneNumber
                        });
                        if (this.props.onProviderSelected) {this.props.onProviderSelected(true);}
                    }}
                    onLookupError={null}
                    cssWrapper="control-size-430 mt-25 mb-10"
                    type={this.props.type}
                    required={this.state.isAddManual || data?.Name ? null : "Please enter a provider"}
                    disabled={this.props.hasCertificatedSharesAndEquities}
                />
                {!this.state.isAddManual && <p className="text-bold">{data?.Name}</p>}
                {!this.state.isAddManual && this.props.showElectronicRerRegistrationSupported && data?.Name && (
                    <>
                        <TextBoxEditor
                            label={"Electronic re-registration supported?"}
                            cssWrapper="control-size-430"
                            value={this.getElectronicRgistrationValue()}
                            disabled={true}
                        />
                    </>
                )}
                {SubAccountTypeHelper.isPP(this.props.type) && this.props.jouneryType != processTypeEnum.Quote && (
                    <TextBoxEditor
                        cssWrapper="control-size-430 mt-25"
                        disabled={data?.Name?.toLowerCase() == "standard life savings ltd wrap"}
                        label="Account number at custodian"
                        value={this.props.externalOwnerShip?.PolicyNumber}
                        maxLength={45}
                        onChange={(v) => {
                            this.props.onAccountNumberChange(v);
                        }}
                        infoText="This transfer will be processed more quickly if the account number is entered"
                    />
                )}

                {!this.props.hasCertificatedSharesAndEquities && (
                    <div>
                        <button
                            className={this.state.isManualCedingSchemeExpanded ? "circle-remove-button" : "add-button"}
                            onClick={() => {
                                this.setState({
                                    isAddManual: true,
                                    isManualCedingSchemeExpanded: !this.state.isManualCedingSchemeExpanded,
                                });
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">{this.state.mannuallyName || "Add manually"}</span>
                        </button>
                    </div>
                )}
                {this.state.isAddManual && this.state.isManualCedingSchemeExpanded && (
                    <>
                        <TextBoxEditor
                            label={"Provider scheme reference"}
                            required="Please enter Provider scheme reference"
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430 mt-20"
                            value={data?.Reference}
                            onChange={(v) => onChange({ Reference: v })}
                        />
                        <TextBoxEditor
                            label={"Provider contact name"}
                            required="Please enter Provider contact name"
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            value={data?.ContactName}
                            onChange={(v) => onChange({ ContactName: v })}
                        />
                        <TextBoxEditor
                            label={"Provider contact phone"}
                            required="Provider contact phone"
                            regex={{ errorMessage: errorMsg.phone, value: phoneWithSpaceAndPlusSign }}
                            cssWrapper="control-size-430"
                            value={data?.PhoneNumber}
                            onChange={(v) => onChange({ PhoneNumber: v })}
                        />
                        <TextBoxEditor
                            label={"Name of provider"}
                            required="Please enter name of the provider"
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            value={data?.Name}
                            onChange={(v) => {
                                onChange({ Name: v });
                            }}
                        />
                        <TextBoxEditor
                            label={"Provider address line 1"}
                            required="Please enter Provider address"
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            onChange={(v) => this.onDataChange(onChange, { Line1: v }, data, "Address")}
                            value={data?.Address?.Line1}
                        />
                        <TextBoxEditor
                            label={"Provider address line 2"}
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            onChange={(v) => this.onDataChange(onChange, { Line2: v }, data, "Address")}
                            value={data?.Address?.Line2}
                        />
                        <TextBoxEditor
                            label={"Provider address line 3"}
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            onChange={(v) => this.onDataChange(onChange, { Line3: v }, data, "Address")}
                            value={data?.Address?.Line3}
                        />
                        <TextBoxEditor
                            label={"Postcode"}
                            regex={{ errorMessage: errorMsg.noSpecial, value: NoSpecial }}
                            cssWrapper="control-size-430"
                            onChange={(v) => this.onDataChange(onChange, { Postcode: v }, data, "Address")}
                            value={data?.Address?.Postcode}
                        />
                        <button
                            className="btn secondary mr-10"
                            onClick={() => {
                                this.props.onChange({ Name: null });
                                this.hideAddManual();
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn primary"
                            onClick={() => {
                                if( this.isAddManualFilled() ) {
                                    this.setState({
                                        isManualCedingSchemeExpanded: false,
                                        mannuallyName: data?.Name,
                                    });
                                }
                                else {
                                    this.props.showErrorMsgPopUp(
                                        [`Manually filled ceding scheme is missing required data.`],
                                        true
                                    );
                                }
                            }}
                        >
                            Save
                        </button>
                    </>
                )}
            </>
        );
    }
}
